/**
 * Gets the sum of the specified values. If no values, returns 0.
 * DEPRECATED: Use lodash's sum() instead
 */
export function sum(values: number[]): number {
    return (values || []).reduce((a, b) => a + b, 0);
}
